import { render, staticRenderFns } from "./NavigationBreadcrumb.vue?vue&type=template&id=45c49312&scoped=true&"
import script from "./NavigationBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./NavigationBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./NavigationBreadcrumb.vue?vue&type=style&index=0&id=45c49312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c49312",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBreadcrumbs,VIcon})
